import logo from "../../logo/ATA_blue.png";
type ATALogoProps = {
  logoRef: React.MutableRefObject<HTMLDivElement>;
};
export const ATALogo = ({ logoRef }: ATALogoProps) => {
  return (
    <div ref={logoRef}>
      <img src={logo} alt="ATALogo" />
    </div>
  );
};
